var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2D6CDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18102_133891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6404 11.1601C19.3454 11.1601 19.106 10.9207 19.106 10.6257C19.106 8.57944 18.3095 6.65642 16.8631 5.20933C16.6544 5.00059 16.6544 4.66217 16.8631 4.45343C17.0718 4.24469 17.4103 4.24469 17.6191 4.45343C19.2671 6.10209 20.1748 8.29451 20.1748 10.6257C20.1748 10.9207 19.9354 11.1601 19.6404 11.1601Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03438 11.1595C4.7394 11.1595 4.5 10.9201 4.5 10.6251C4.5 8.29386 5.40776 6.10143 7.05642 4.45343C7.26516 4.24469 7.60371 4.24469 7.81245 4.45343C8.02119 4.66217 8.02119 5.00072 7.81245 5.20946C6.36536 6.65577 5.56875 8.57879 5.56875 10.6251C5.56875 10.9201 5.32935 11.1595 5.03438 11.1595Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3374 20.6008C10.864 20.6008 9.66553 19.4024 9.66553 17.9289C9.66553 17.6339 9.90493 17.3945 10.1999 17.3945C10.4949 17.3945 10.7343 17.6339 10.7343 17.9289C10.7343 18.8132 11.4531 19.532 12.3374 19.532C13.2215 19.532 13.9405 18.8132 13.9405 17.9289C13.9405 17.6339 14.1799 17.3945 14.4749 17.3945C14.7699 17.3945 15.0093 17.6339 15.0093 17.9289C15.0093 19.4024 13.8108 20.6008 12.3374 20.6008Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2156 18.4637H6.45936C5.7717 18.4637 5.2124 17.9044 5.2124 17.2168C5.2124 16.8519 5.37131 16.5065 5.64854 16.2692C6.73216 15.3536 7.3499 14.0227 7.3499 12.6127V10.6261C7.3499 7.87598 9.58721 5.63867 12.3375 5.63867C15.0876 5.63867 17.3249 7.87598 17.3249 10.6261V12.6127C17.3249 14.0227 17.9427 15.3536 19.0193 16.2642C19.3035 16.5065 19.4624 16.8519 19.4624 17.2168C19.4624 17.9044 18.9032 18.4637 18.2156 18.4637ZM12.3375 6.70742C10.1764 6.70742 8.41865 8.46515 8.41865 10.6261V12.6127C8.41865 14.3375 7.66275 15.9664 6.34534 17.08C6.32042 17.1014 6.28115 17.1456 6.28115 17.2168C6.28115 17.3136 6.36243 17.3949 6.45936 17.3949H18.2156C18.3124 17.3949 18.3937 17.3136 18.3937 17.2168C18.3937 17.1456 18.3546 17.1014 18.3309 17.0814C17.0121 15.9664 16.2562 14.3375 16.2562 12.6127V10.6261C16.2562 8.46515 14.4985 6.70742 12.3375 6.70742Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3374 6.70625C12.0424 6.70625 11.803 6.46685 11.803 6.17188V4.03438C11.803 3.7394 12.0424 3.5 12.3374 3.5C12.6323 3.5 12.8717 3.7394 12.8717 4.03438V6.17188C12.8717 6.46685 12.6323 6.70625 12.3374 6.70625Z",
    fill: "#2D6CDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18102_133891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(2.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.40a0ed9ce2cc1493308b932acf701bcd.svg";
export { ForwardRef as ReactComponent };